<template>
  <div class="page-container">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="100px">
      <div class="top-layout">
        <div class="left-panel">
          <!-- 左侧表单内容：卡源、资费类型、总流量... -->
            <el-form-item label="卡号列表" prop="iccids">
                <el-input v-model="propsParams.iccids" type="textarea" clearable placeholder="请输入内容" rows="8"></el-input>
            </el-form-item>
            <el-form-item label="卡号范围" class="card-range-item">
              <div class="card-range-wrapper">
                <div class="card-range-input-container">
                  <el-form-item prop="iccidStart" class="inner-form-item">
                    <el-input
                      v-model="propsParams.iccidStart"
                      clearable
                      placeholder="包含开始值"
                      class="card-range-input"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="separator">-</div>
                <div class="card-range-input-container">
                  <el-form-item prop="iccidEnd" class="inner-form-item">
                    <el-input
                      v-model="propsParams.iccidEnd"
                      clearable
                      placeholder="包含终止值"
                      class="card-range-input"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
        </div>
      </div>
      <div class="bottom-layout">
        <el-button type="success" size="mini" @click="openSelectProdcut">配置套餐</el-button>
        <div class="table-container">
          <el-table :data="propsParams.countryPrices"  height="100%" >
            <el-table-column label="套餐名称" prop="productName"  align="center" width="180" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="套餐类型" align="center" prop="status" width="80">
              <template slot-scope="scope">
                <el-tag>{{transferProductType(scope.row.productType)}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="套餐总量/M" prop="flowCount" align="center" width="120" :show-overflow-tooltip="true" />
            <el-table-column label="套餐有效期/天" prop="validityTime" align="center" width="120" :show-overflow-tooltip="true" />
            <el-table-column prop="channel" label="渠道" align="center" width="100px">
              <template slot-scope="{row}">
                <span v-if="row.channel == 'cmlink'">ZY国际</span>
                <span v-if="row.channel == 'cmBrazil'">中移巴西</span>
                <span v-if="row.channel == 'multi'">RX国际</span>
              </template>
            </el-table-column>
            <el-table-column prop="countryNames" label="限制区域和价格" align="center" width="670">
              <template slot-scope="{row}">
                <div class="card_product-list" v-if="row.products && row.products.length > 0">
                  <div class="product-item" v-for="(item,index) in row.products.slice(0, 2)" :key="index" :title="item">
                      <span>【{{item.name}}】：  售价({{item.currencySymbol}}{{item.price}})</span>
                  </div>
                  <span class="el-dropdown-link" v-if="row.products.length>2" @click="showMoreProduct(row)">
                    <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                  </span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-circle-close"
                  @click="customProductCancel(scope.row)"
                >移除</el-button>
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-edit"
                  @click="customProductEdit(scope.row)"
                >修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="submit-footer">
        <el-button class="submit-btn" type="primary"  @click="handleSubmit">提交</el-button>
      </div>
    </el-form>
    <!-- 选择套餐 -->
    <select-internation-product ref="select" @selection-submitted="handleSelectionSubmitted" />
    <el-dialog title="配置限制区域和价格" :visible.sync="nextOperatorOpen" width="1300px"  :modal-append-to-body="true">
      <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
        <div style="display: flex; justify-content: space-between; width: 100%;">
          <div style="flex: 1; text-align: left;">
            <el-form-item prop="countryName">
              <el-input v-model="queryParams.countryName"  placeholder="区域名称" clearable style="width: 210px" @keyup.enter.native="search" />
            </el-form-item>
            <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
          </div>
          <div style="flex: 1; text-align: left;">
            <el-form-item>
              <el-input v-model="basePrice" placeholder="人民币价格" style="width:130px"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <el-button type="primary" @click="handleUpdateBasePrice" style="margin-left: 10px">按汇率设置价格</el-button>
            </el-form-item>
          </div>
        </div>
        
      </el-form>
      <div class="dialog-operator">
        <el-table ref="treeTable" :data="countryGroupData" @selection-change="handleSelectionChange" :row-class-name="hideCheckbox" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column type="selection" align="center" width="60px"></el-table-column>
          <el-table-column prop="name" label="限制区域" align="center" width="180">
            <span  slot="header">
                <el-tooltip content="通过国际群组，将限制的国家分组" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
                  限制区域
            </span>
          </el-table-column>
          <el-table-column prop="countryNames" label="限制国家" align="center" width="180">
            <span  slot="header">
                <el-tooltip content="可以使用的国家，超出区域，停机处理" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
                  限制国家
            </span>
            <template slot-scope="{row}">
              <div class="product-list" v-if="row.countryNames && row.countryNames.length > 0">
                <div class="product-item" v-for="(item,index) in row.countryNames.slice(0, 1)" :key="index" :title="item">
                      <span>{{item}}</span>
                </div>
                <span class="el-dropdown-link" v-if="row.countryNames.length>1" @click="showMoreCountry(row)">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="支付货币" align="center" width="180">
            <span  slot="header">
                <el-tooltip content="可以切换的支付货币" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
                  支付货币
            </span>
            <template #default="{ row }">
              <el-select
                v-model="row.currency"
                filterable
                allow-create
                default-first-option
                placeholder="请选择货币代码"
                style="width: 140px"
                @change="handleCurrencyChange(row)"
              >
                <el-option
                  v-for="item in currencyList"
                  :key="item.id"
                  :label="item.name + '[' + item.currency + ']'"
                  :value="item.currency"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="exchangeRateCny" label="汇率" align="center" width="120"></el-table-column>
          <el-table-column prop="currencySymbol" label="货币符号" align="center" width="120"></el-table-column>
          <el-table-column prop="price" label="售价" align="center" min-width="200">
            <span  slot="header">
                <el-tooltip content="比例代理商H5展示价格" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
                  支付售价
            </span>
            <template #default={row}>
              <el-input style="width: 170px;"  v-model="row.price"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                <template slot="append">{{row.currencySymbol}}</template>
                </el-input>
            </template>
          </el-table-column>
          
          <!-- 新增操作列 -->
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <template v-if="row.leaf" >
                <i class="el-icon-remove-outline" @click="removeCurrencyRow('treeTable',row)" style="font-size:25px;color: #ff4949"></i>
              </template>
              <template v-else>
                <i class="el-icon-remove-outline" @click="removeParentCurrencyRow(row)" style="font-size:25px;color: #ff4949;margin-left:10px"></i>
                <i class="el-icon-circle-plus-outline" @click="addCurrencyRow('treeTable',row)" style="font-size:25px;color: #1890ff;margin-left:10px"></i>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
			<div class="dialog-footer" slot="footer">
				<el-button @click="confirmCountry" type="primary" plain>确认添加</el-button>
			</div>
    </el-dialog>
    <!-- 展示更多国家列表 -->
    <el-dialog title="国家列表" :visible.sync="moreCountryOpen" width="600px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
       <div class="tag-container">
        <el-tag
          v-for="item in filteredTableData"
          :key="item"
          type="success"
          class="custom-tag"
        >
          {{ item }}
        </el-tag>
      </div>
    </el-dialog>
    <!-- 展示更多套餐 -->
    <el-dialog title="区域价格列表" :visible.sync="moreProductOpen" width="900px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchProductQuery" clearable style="width: 30%"></el-input>
      <el-table :data="filteredProductData" height="650"  style="width: 100%">
        <el-table-column prop="name" label="使用区域"></el-table-column>
        <el-table-column prop="groupKey" label="区域编码"></el-table-column>
        <el-table-column prop="currency" label="收款货币代码" ></el-table-column>
        <el-table-column prop="currencySymbol" label="收款货币符号"></el-table-column>
        <el-table-column prop="price" label="售价"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import selectInternationProduct from "./selectInternationProduct";
import { selectGroups , saveInternationalCardProduct } from "@/api/international.js";
import { currencyList } from "@/api/config.js"
import { listChannel } from "@/api/api.js";
export default {
  name: "internationalCustomizeCardProduct",
  components: { selectInternationProduct },
  data() {
    let validateOperator = (rule, value, callback) => {
      let scs = this.propsParams.countryPrices
      if(scs.length == 0){
        callback(new Error('请配置套餐售卖国家价格'));
      }else{
        callback();
      }
    }
    return {
      internationalPrice:"",
      propsParams: {
        channel:undefined,
        countryPrices:[
        ]
      },
      ruleValidate: {
      },
      nextOperatorOpen:false,
      queryParams:{
        countryName:undefined
      },
      preSelectedIds: [],
      countryGroupData:[],
      currentRow:{},
      currencyList:[],
      multipleSelectionCountry:[],
      moreCountryOpen:false,
      moreCountryData:[],
      searchQuery:'',
      channels:[],
      moreProductOpen:false,
      moreProductData:[],
      searchProductQuery:'',
      basePrice:'',

    };
  },
  computed: {
    filteredTableData() {
      return this.moreCountryData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    },
    filteredProductData() {
      return this.moreProductData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchProductQuery.toLowerCase());
        });
      });
    }
  },
  methods: {
    hideCheckbox({ row, rowIndex }) {
      // 根据条件决定是否隐藏复选框
      if (row.leaf) {
        return 'hide-checkbox';
      }
      return '';
    },
    transferProductType(status) {
      let obj = {
        1: "累计套餐",
        2: "月套餐",
        3: "加油包套餐",
        4: "停机保号套餐",
        5: "补卡套餐",
        6: "加速包套餐",
        7: "测试套餐",
        8: "赠送套餐",
        9: "发票套餐",
        10: "流量池加油包"
      };
      return obj[status];
    },
    initChannel(){
      let operatorId = '4'
      listChannel({operatorId}).then(res=>{
        this.channels = res.data.data
      })
    },
    //查找货币
    getCurrencyList(){
      currencyList().then(res=>{
        this.currencyList = res.data.data
      })
    },
    openSelectProdcut() {
      this.$refs.select.show();
    },
    //处理选中的套餐
    handleSelectionSubmitted(selectedItems){
      if (!selectedItems || selectedItems.length === 0) {
        return;
      }
      selectedItems.forEach(selectedItem => {
        // 检查父组件集合中是否已存在该选中项
        const exists = this.propsParams.countryPrices.some(item => item.id === selectedItem.id);
        if (!exists) {
          // 若不存在，则添加到父组件集合中
          this.propsParams.countryPrices.push(selectedItem);
        }
      });

    },
    addCurrencyRow(ref,row) {
      if (!row.children) {
        this.$set(row, 'children', []);
      }
      const newRow = {
        id: `${row.id}_${row.children.length + 1}`,
        parentId: row.id,
        productId: row.productId,
        groupKey: row.groupKey,
        name: '',
        englishName: '',
        currency: '',
        currencySymbol: '',
        price: '',
        leaf : true  //标记为叶子节点
      };
      // 将新行添加到当前行的 children 数组中
      row.children.push(newRow);
      this.$nextTick(() => {
        this.$refs[ref].toggleRowExpansion(row, true);
      });
    },
    handleCurrencyChange(row){
      const selectedCurrency = this.currencyList.find(
        item => item.currency === row.currency
      );
      if (selectedCurrency) {
        row.currencySymbol = selectedCurrency.currencySymbol;
        row.exchangeRateCny = selectedCurrency.exchangeRateCny
        const basePrice = Number(this.basePrice);
        if (!isNaN(basePrice) && basePrice > 0) {
          const exchangeRate = Number(row.exchangeRateCny);
          if (!isNaN(exchangeRate) && exchangeRate > 0) {
            const calculatedPrice = (basePrice * exchangeRate).toFixed(2);
            this.$set(row, 'price', calculatedPrice);
          }
        }
      }
    },
    handleUpdateBasePrice(){
      let price = this.basePrice
      if (isNaN(price) || price <= 0) {
        this.$message.warning("请输入有效的人民币价格");
        return;
      }
      const updateItemPrice = (item) => {
        const exchangeRate = Number(item.exchangeRateCny);
        // 检查汇率是否有效，有效则更新价格
        if (!isNaN(exchangeRate) && exchangeRate > 0) {
          const calculatedPrice = (price * exchangeRate).toFixed(2);
          this.$set(item, 'price', calculatedPrice);
        }
        // 如果有子节点，递归处理子节点
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => updateItemPrice(child));
        }
      };
      // 遍历顶层节点并递归处理
      this.countryGroupData.forEach(item => {
        updateItemPrice(item);
      });
    },
    removeCurrencyRow(type,row) {
      let data = this.countryGroupData
      const parentRow = data.find(item => item.id === row.parentId);
      if(parentRow  && parentRow.children){
        const childIndex = parentRow.children.findIndex(child => child.id === row.id);
        if(childIndex !== -1){
          parentRow.children.splice(childIndex, 1);
        }
      }
    },
    removeParentCurrencyRow(row){
      let data =  this.countryGroupData
      const parentIndex = data.findIndex(item => item.id === row.id);
      if(parentIndex !== -1){
        data.splice(parentIndex, 1);
      }
    },
    // 创建套餐
    handleSubmit() {
      let { iccids } = this.propsParams;
      let params = {
        ...this.propsParams,
        iccids:iccids ? iccids.split("\n") : []
      };
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          saveInternationalCardProduct(params).then(res => {
            this.$message.success("添加套餐成功");
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$router.push({ path: `/international/internationalCardProduct` });
          });
        }
      });
    },
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    search(){
      this.handleSelectGroupsData()
    },
    handleUpdateInternationalPrice(){
      let price = this.internationalPrice
      this.propsParams.countryPrices.forEach((item, index) => {
        this.$set(this.propsParams.countryPrices[index], 'price', price);
      });
    },
    handleSelectionChange(select){
      this.multipleSelectionCountry = select
    },
    confirmCountry(){
      this.nextOperatorOpen = false
      const flattenItems = (items) => {
        let result = [];
        items.forEach(item => {
          result.push(item);
          if (item.children && item.children.length > 0) {
            result = result.concat(flattenItems(item.children.map(child=>{
              child.name = item.name
              return child;
            })));
          }
        });
        return result;
      };
      const allSelectedItems = flattenItems(this.multipleSelectionCountry);
      if (!this.currentRow.products) {
        this.$set(this.currentRow, 'products', []);
      }
      allSelectedItems.forEach(selectedItem => {
        const productList = this.currentRow.products;
        // 检查是否已存在于 this.currentRow.products 中
        // const exists = productList.some(product => product.id === selectedItem.id);
        const index = productList.findIndex(product => product.id === selectedItem.id);
        if(index !== -1){
          this.$set(this.currentRow.products, index, selectedItem);
          const preSelectedIndex = this.preSelectedIds.indexOf(selectedItem.id);
          if (preSelectedIndex !== -1) {
            this.preSelectedIds[preSelectedIndex] = selectedItem.id;
          }
        }else{
          this.$set(this.currentRow.products, this.currentRow.products.length, selectedItem);
          this.preSelectedIds.push(selectedItem.id);
        }
        // if (!exists) {
        //   this.$set(this.currentRow.products, this.currentRow.products.length, selectedItem);
        //   this.preSelectedIds.push(selectedItem.id)
        // }
      });
    },
    showMoreCountry(item){
      this.moreCountryOpen = true
      this.moreCountryData = item.countryNames
    },
    customProductEdit(product){
      this.nextOperatorOpen = true
      this.currentRow = product;
      this.handleSelectGroupsData()
    },
    customProductCancel(product){
      let services = this.propsParams.countryPrices;
      for (let i = services.length - 1; i >= 0; i--) {
        if(services[i].id === product.id){
          services.splice(i, 1);
        }
      }
    },
    handleSelectGroupsData(){
      let channel = this.currentRow.channel
      let name = this.queryParams.countryName
      selectGroups({channel,name}).then(res=>{
        let  countryData = res.data.data
        countryData.forEach(item=>{
          item.productId = this.currentRow.id
          item.price = 0
        })
        this.countryGroupData = countryData
        this.$nextTick(() => {
          // 在数据更新后，设置指定行的复选框为选中状态
          this.countryGroupData.forEach(row => {
            if (this.preSelectedIds.includes(row.id)) {
              this.$refs.treeTable.toggleRowSelection(row, true);
            }
          });
        });

      })
    },
    showMoreProduct(item){
      this.moreProductOpen = true
      this.moreProductData = item.products
    },
  },
  mounted() {
  },
  created() {
    this.getCurrencyList()
    this.initChannel()
  }
};
</script>
<style scoped lang="less">
.page-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 90vh; /* 确保占满浏览器可视区域 */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  .top-layout {
    flex: 0 0 30%; 
    display: flex;
    overflow: hidden; 
    // border-bottom: 1px solid #eee; 
  }
  // 左侧部分
  .left-panel {
    width: 60%; /* 左右各占一半 */
    overflow-y: auto;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    // border-right: 1px solid #eee; 
  }
  //下半部分
  .bottom-layout {
    //固定底部占 70% 高度
    flex: 0 0 70%;      
    padding: 20px;
    box-sizing: border-box;
    padding-bottom: 80px;
  }
  .submit-footer {
    position: absolute;  
    bottom: 0;           
    left: 0;             
    width: 100%;         
    padding: 20px;       
    box-sizing: border-box; 
    z-index: 99;
  }

  .table-container {
    height: 260px; /* 减去表单元素高度（根据实际调整） */
    overflow: hidden;
  }

    .card-range-item {
        margin-bottom: 20px;

        .card-range-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .card-range-input-container {
            flex: 1;
        }

        .separator {
            font-size: 18px;
            font-weight: bold;
            color: #606266;
            padding: 0 10px;
        }

        .inner-form-item {
            margin-bottom: 0;
        }

        .card-range-input {
            width: 100%;
            height: 40px;
            border-radius: 6px;
            &:hover {
            border-color: #409EFF;
            }
            &.is-focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
            }
        }
    }

}

.dialog-operator{
    overflow: auto;
    max-height: 434px;
    border-top: 1px solid #eff1f4;
    border-bottom: 1px solid #eff1f4;
    padding: 0px 10px 11px 27px;

    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #8798AF;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
}
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 600px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 60px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px; 
  padding-top: 10px; 
  .custom-tag {
    margin: 0; 
  }
}

.card_product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 660px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 290px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
</style>
